import { HStack, Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';
import { PiCheckCircle, PiWarningCircle } from 'react-icons/pi';
import {
  UserAvatarStatus,
  UserFaceIdStatus,
} from '../../../../../models/users';

enum FaceIdStatusLabel {
  ENABLED = 'FaceID configurado',
  DISABLED = 'FaceID não configurado',
}

enum FaceIdStatusColor {
  ENABLED = 'green',
  DISABLED = 'gray',
}

enum AvatarStatusLabel {
  EMPTY = 'O FaceID não poderá ser {action} sem o envio de uma foto',
  VALID = 'O FaceID será {action} automaticamente ao salvar os dados',
  INVALID = 'O FaceID não poderá ser {action}',
  NOT_VERIFIED = 'O FaceID não poderá ser {action}',
  UNAVAILABLE = 'FaceID desativado',
}

enum AvatarStatusColor {
  EMPTY = 'gray',
  VALID = 'green',
  INVALID = 'yellow',
  NOT_VERIFIED = 'yellow',
  UNAVAILABLE = 'gray',
}

interface IFaceIdStatusTagProps {
  faceIdStatus?: UserFaceIdStatus;
  avatarStatus?: UserAvatarStatus;
  avatarChanged: boolean;
}

const FaceIdStatusTag = ({
  faceIdStatus = UserFaceIdStatus.DISABLED,
  avatarStatus = UserAvatarStatus.EMPTY,
  avatarChanged,
}: IFaceIdStatusTagProps): JSX.Element => {
  let color = FaceIdStatusColor[faceIdStatus].toString();
  let label = FaceIdStatusLabel[faceIdStatus].toString();

  if (avatarChanged) {
    color = AvatarStatusColor[avatarStatus];

    const action =
      faceIdStatus === UserFaceIdStatus.ENABLED ? 'atualizado' : 'configurado';

    label = AvatarStatusLabel[avatarStatus]
      ?.toString()
      .replace('{action}', action);
  }

  return (
    <HStack spacing={4}>
      <Tag size="lg" variant="outline" colorScheme={color} py={1.5}>
        <TagLeftIcon
          as={
            faceIdStatus === UserFaceIdStatus.ENABLED
              ? PiCheckCircle
              : PiWarningCircle
          }
          fontSize={24}
        />
        <TagLabel fontWeight="normal">{label}</TagLabel>
      </Tag>
    </HStack>
  );
};

export default FaceIdStatusTag;
